// extracted by mini-css-extract-plugin
export default {"card__content":"DocumentItem_card__content__lmeq9","item":"DocumentItem_item__4yKg1"};